const indicatorKeys = [
  { id: 'text', name: 'cruds.indicators.type.text' },
  { id: 'numeric', name: 'cruds.indicators.type.number' },
  { id: 'boolean', name: 'cruds.indicators.type.boolean' },
  { id: 'static', name: 'cruds.indicators.type.static' },
  { id: 'image', name: 'cruds.indicators.type.image' },
]
export default indicatorKeys
